var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 345.18755539924535,
    y: 345.18755539924535,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    height: 59.6,
    width: 26,
    y: 10.1,
    x: 27.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    height: 9.6,
    width: 26,
    y: 10.1,
    x: 27.9
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    height: 9.6,
    width: 26,
    y: 60.1,
    x: 27.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.c1be39097a1a5c655fc751e7605ef2fb.svg";
export { ForwardRef as ReactComponent };